/**
 * @param {import("../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/metrics",
    },
    (router) => {
      router.push({
        id: "@api/metric@search",
        path: "",
      });
    },
  );
}
